import { fetch, getCookie } from "@szgc/plt-core-v2";

/*去除左右空格*/
export const trim = (s: any) => {
  return s.replace(/(^\s*)|(\s*$)/g, "");
};

/*时间转换*/
export const dateFormat = (date: any) => {
  if (date) {
    const dateTime = new Date(date);
    const Y = dateTime.getFullYear() + "-";
    const M =
      (dateTime.getMonth() + 1 < 10 ? "0" + (dateTime.getMonth() + 1) : dateTime.getMonth() + 1) +
      "-";
    const D = (dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate()) + " ";
    const h = (dateTime.getHours() < 10 ? "0" + dateTime.getHours() : dateTime.getHours()) + ":";
    const m =
      (dateTime.getMinutes() < 10 ? "0" + dateTime.getMinutes() : dateTime.getMinutes()) + ":";
    const s = dateTime.getSeconds() < 10 ? "0" + dateTime.getSeconds() : dateTime.getSeconds();
    return Y + M + D + h + m + s;
  }
  return "";
};

/*生成随机字符串*/
export const getRandomString = (capacity: number) => {
  const chars = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z"
  ];
  let res = "";
  for (let i = 0; i < capacity; i++) {
    const id = Math.ceil(Math.random() * chars.length);
    res += chars[id];
  }
  return res;
};

/*设置iframe高度*/
export const setIframeHeight = (window: any, iframe: any) => {
  window.wbenchIframeTimer = null;
  window.wbenchIframeCount = 0;
  window.wbenchIframeTimer = setInterval(() => {
    if (window.wbenchIframeCount > 4) {
      clearInterval(window.wbenchIframeTimer);
      window.wbenchIframeTimer = null;
      window.wbenchIframeCount = 0;
    } else {
      try {
        const bHeight: number = iframe.contentWindow.document.body.scrollHeight;
        const dHeight: number = iframe.contentWindow.document.documentElement.offsetHeight;
        iframe.height = Math.max(bHeight, dHeight) + 20;
        window.wbenchIframeCount++;
      } catch (error) {
        clearInterval(window.wbenchIframeTimer);
        window.wbenchIframeTimer = null;
        window.wbenchIframeCount = 0;
      }
    }
  }, 1000);
};

function resetWidgetLimitConfig(widget: App.WebForm.Widget, properties: App.Source.Property[]) {
  const typeList = ["selectors", "selector", "checkBox", "dictionary", "dictionaries"];
  if (typeList.indexOf(widget.property.propertyType) < 0) return;

  const property = properties.find((d) => d.propertyName === widget.property.propertyName);
  if (!property) return;

  if (!property.configValue) return;

  widget.property.configValue = property.configValue;
}

/**
 * 刷新表单组件配置中的limit配置
 */
export async function refreshdWidgetLimitConfig(config: App.WebForm.ServiceOriginConfig) {
  const prefix = getCookie("plt-api-route") || "";
  const options = JSON.parse(config.formRenderData) as App.WebForm.Config;
  if (!localStorage.getItem("offline") || localStorage.getItem("offline") === "false") {
    options.businessName = config.businessName;

    let properties: App.Source.Property[];
    try {
      const { success, data } = await fetch.get<App.Source.Property[]>(
        prefix + `/api/appproc//data/package:${config.pacId}/properties`
      );
      if (success) {
        properties = data;
      } else {
        properties = [];
      }
    } catch (error) {
      properties = [];
    }

    if (properties.length > 0) {
      options.widgets.forEach((d) => {
        if (d.isFormWidget) {
          const wproperty = d.property;
          if (wproperty.propertyType === "children") {
            const cwidget = d as App.WebForm.ChildrenTableWidget;
            const cproperty = properties.find(
              (d) => d.propertyName === cwidget.property.propertyName
            );
            const cproperties = cproperty?.children || [];
            cwidget.children.forEach((w) => {
              resetWidgetLimitConfig(w, cproperties);
            });
          } else {
            resetWidgetLimitConfig(d, properties);
          }
        }
      });
    }

    options.businessName = config.businessName;
  }

  return options;
}

